module.exports = __webpack_public_path__ + "static/media/angular.ac259b63.png";